import React, { Component } from 'react';
import { connect } from "react-redux";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class ReportsHeader extends Component {

    constructor(props) {
        super(props);



    }


    render() {
        const { t } = this.props;
        return (
            <React.Fragment>

                <div className="settings-header-top">
                    {this.props.title}
                </div>


            </React.Fragment>
        );
    }
}


export default ReportsHeader;
